import React, { useState } from "react";
import { Button, Flex, Form, Input, Modal } from "antd";
import { mdiCheckCircle, mdiCheckCircleOutline, mdiCloseCircle } from "@mdi/js";
import Icon from "@mdi/react";
import PasswordChecklist from "react-password-checklist"

ChangePasswordForm.defaultProps = {
  submitBtnTxt: "Submit"
}

export default function ChangePasswordForm(props: {submitBtnTxt: string, submit: Function}){
  const [password, setPassword] = useState("");
  const [confirm, setPasswordConfirm] = useState("");

  return (
    <Form
      autoComplete="off"
      layout="vertical"
      variant="filled"
      onFinish={(formValues)=>props.submit(formValues)}
    >
      <label>Enter New Password</label>
      <Form.Item
        label="New Password"
        name="password"
        rules={[
          { required: true, message: 'Please input your password!'}, 
          { min: 8, message: 'Password must be at least 8 characters'},
          { pattern: /.*[0-9].*/, message: "Password must have at least 1 number" },
          { pattern: /.*[a-z].*/, message: "Password must have at least 1 lowercase" },
          { pattern: /.*[A-Z].*/, message: "Password must have at least 1 uppercase" },
          { pattern: /[@./#&+-]/g, message: "Password must have at least 1 of these symbols" },
        ]}
      >
        <Input.Password placeholder="Enter New Password" onChange={e => setPassword(e.target.value)}/>
      </Form.Item>
      <Form.Item
        label="Confirm Password"
        name="confirm"
        dependencies={['password']}
        rules={[
          { required: true, message: 'Please confirm your password!'},
          ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue('password') === value) {
                return Promise.resolve();
              }
              return Promise.reject(new Error('The new password that you entered do not match!'));
            },
          }),
        ]}
      >
        <Input.Password placeholder="Confirm Password" onChange={e => setPasswordConfirm(e.target.value)}/>
      </Form.Item>

      <div className="password-requirements">
        <p>Password must contain:</p>
        <PasswordChecklist
          rules={["minLength","specialChar","number","capital","lowercase"]}
          minLength={8}
          maxLength={15}
          specialCharsRegex={/[@./#&+-]/g}
          value={password}
          valueAgain={confirm}
          iconComponents={{
            ValidIcon: <Icon path={mdiCheckCircle} size={1} />, 
            InvalidIcon: <Icon path={mdiCloseCircle} size={1} />
          }}
          onChange={(isValid) => {}}
          messages={{
            minLength: "8 to 15 characters",
            specialChar: "1 symbol from: @./#&+-",
            number: "1 number",
            capital: "1 uppercase",
            lowercase: "1 lowercase",
          }}/>
      </div>

      <Flex align="center" justify="center">
        <Button type="primary" htmlType="submit">
          {props.submitBtnTxt}
        </Button>
      </Flex>
    </Form>
  )
}